import styled from "styled-components/macro";
import { device, toRem } from "./Breakpoints";
import { colors, fontStyle } from "./Theme";

//Mixins
export const shadow = `
  box-shadow: 
    0 1px 1px rgba(0, 0, 0, 0.11), 
    0 2px 2px rgba(0, 0, 0, 0.11),
    0 4px 4px rgba(0, 0, 0, 0.11),
    0 6px 8px rgba(0, 0, 0, 0.11),
    0 8px 16px rgba(0, 0, 0, 0.11);
`;

export const smallShadow = `
  box-shadow: 
  0 -2px 6px rgba(0, 0, 0, 0.05),
  0 1px 1px rgba(0, 0, 0, 0.05),
  0 3px 3px rgba(0, 0, 0, 0.05), 
  0 4px 6px rgba(0, 0, 0, 0.05),
  0 6px 8px rgba(0, 0, 0, 0.05);
`;

export const blueGradient = `
background: rgb(0,88,148);
background: linear-gradient(90deg, rgba(0,88,148,1) 0%, rgba(0,145,244,1) 50%, rgba(0,88,148,1) 100%);
`;

export const defaultHorizontalMargin = `
  margin-left:  ${toRem(10)};
  margin-right:  ${toRem(10)};

  @media only screen and (${device.tablet}) {
    margin-left:  ${toRem(20)};
    margin-right:  ${toRem(20)};
  }
`;

export const defaultVerticalPadding = `
padding-top: ${toRem(10)};
  padding-bottom: ${toRem(10)};

  @media only screen and (${device.tablet}) {
    padding-top: ${toRem(20)};
    padding-bottom: ${toRem(20)};
  }
`;

export const Spacer = styled.div`
  width: 100%;
  height: 12px;

  @media only screen and (${device.laptop}) {
    height: 20px;
  }
`;

export const noSelect = `
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
`;

export const panelBackground = `
  background-color: white;
  -webkit-box-shadow: 0px 3px 26px -8px rgba(0, 0, 0, 0.49);
  -moz-box-shadow: 0px 3px 26px -8px rgba(0, 0, 0, 0.49);
  box-shadow: 0px 3px 26px -8px rgba(0, 0, 0, 0.49);
  `;
//Elements
export const Main = styled.main`
  background-attachment: fixed;
  background-size: cover;
  overflow: auto;
  position: relative;
  min-height: 100vh;
`;

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${toRem(1500)};
`;

export const HoverableText = styled.p<{ fontSize?: number; color?: string }>`
  color: ${(props: any) => (props.color ? props.color : "black")};
  ${noSelect};

  white-space: nowrap;
  &:hover {
    font-weight: 600;
  }
  &::before {
    display: block;
    content: attr(title);
    font-weight: 600;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export const DefaultText = styled.p<{
  fontSize?: number;
  color?: string;
  fontWeight?: string;
}>`
  font-size: ${(props: any) => toRem(props.fontSize ? props.fontSize : 14)};
  color: ${(props: any) => (props.color ? props.color : "black")};
  font-weight: ${(props: any) =>
    props.fontWeight ? props.fontWeight : "normal"};
  ${noSelect};
`;

export const Shadow = styled.div`
  position: absolute;
  width: 100%;
  height: 15px;
  top: -15px;
  left: 0;
  ${shadow};
`;

export const SectionSubTitle = styled(DefaultText)`
  color: ${colors.darkest_gray};
`;

export const MainPrice = styled(DefaultText)`
  font-weight: 700;
  color: black;
  order: 1;

  @media only screen and (${device.tablet}) {
    order: 2;
  }

  @media only screen and (${device.laptop}) {
    order: 1;
  }
`;

export const SecondaryPrice = styled(DefaultText)`
  font-weight: 500;
  text-decoration: line-through;
  color: gray;
  order: 2;
  margin-left: 10px;

  @media only screen and (${device.tablet}) {
    margin-left: 0;
    order: 1;
  }

  @media only screen and (${device.laptop}) {
    order: 2;
    margin-left: 10px;
  }
`;

export const Dim = styled.div<{ percent?: number }>`
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: ${({ percent }) => (percent ? `${percent}%` : "50%")};
`;
